/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import { ImageAspectRatio } from 'models/forms';
import useStyles from './style';

interface Props {
  src: string;
  aspectRatio: ImageAspectRatio;
  onChange: ({ target }: any) => void;
}

const FilledImage: React.FC<Props> = (props) => {
  const { src, aspectRatio, onChange } = props;
  const classes = useStyles();

  return (
    <Box>
      <input
        type='file'
        accept='image/*'
        id='replace-image-button'
        className={classes.input}
        onChange={onChange}
      />
      <label
        htmlFor='replace-image-button'
        className={clsx({
          [classes.containerHorizontal]:
            aspectRatio === ImageAspectRatio.AR_9_16,
          [classes.containerVertical]: aspectRatio === ImageAspectRatio.AR_2_3,
        })}
      >
        <img
          src={src}
          alt='Add Message'
          width='100%'
          height='100%'
          className={classes.image}
        />
      </label>
    </Box>
  );
};

export default FilledImage;
